var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isFetchingData,"can-cancel":false},on:{"update:active":function($event){_vm.isFetchingData=$event}}}),_c('canvas',{ref:"sellingProfitBarChart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }